import { render, staticRenderFns } from "./DroppableFileSelector.vue?vue&type=template&id=4ae2ada4"
import script from "./DroppableFileSelector.vue?vue&type=script&lang=js"
export * from "./DroppableFileSelector.vue?vue&type=script&lang=js"
import style0 from "./DroppableFileSelector.vue?vue&type=style&index=0&id=4ae2ada4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports